import type { KgInsight } from '@api';
import { useKgInsight } from '@terminal/react-query-hooks/insights/useKgInsight';
import { useKgInsightFilter } from '@terminal/react-query-hooks/insights/useKgInsightFilter';
import type { EarningsInsightEmptyStateVariant } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-empty-state/EarningsInsightEmptyState';
import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '@terminal/widgets/earnings-insight-drawer/useEarningsInsightDrawer';

export const useEarningsKgInsightTab = (kgInsight: KgInsight) => {
  const { activeTab } = useEarningsInsightDrawer();

  const earningsEventId = kgInsight.subject.ref?.id ?? '';
  const { data: insights, isLoading: isFilterLoading } = useKgInsightFilter(
    { subject_refs: [{ type: 'earnings', id: earningsEventId }] },
    !!earningsEventId
  );

  const categoryToFind =
    kgInsight.category === 'earnings_preview'
      ? 'earnings_recap'
      : 'earnings_preview';
  const oppositeInsightId = insights?.find(
    insight => insight.category === categoryToFind
  )?.id;

  const { data: oppositeInsight, isLoading: isActiveInsightLoading } =
    useKgInsight(oppositeInsightId ?? '');

  const activeInsight = [kgInsight, oppositeInsight].find(
    insight => insight?.category === activeTab
  );
  const showLoading = isActiveInsightLoading || isFilterLoading;
  const emptyStateVariant: EarningsInsightEmptyStateVariant =
    activeTab === SubTabsType.Recap
      ? 'recap-unavailable'
      : 'preview-unavailable';

  return {
    activeInsight,
    activeTab,
    emptyStateVariant,
    showLoading,
  };
};
